<!--
 * @Author: your name
 * @Date: 2020-08-13 20:52:36
 * @LastEditTime: 2021-02-25 16:43:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/order-history/index.vue
-->
<style lang="sass" scoped>

</style>

<template lang="pug">
  .login
    router-view
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component()

class Login extends Vue {

}

export default Login
</script>
